import Card from 'react-bootstrap/Card';
import ElyisaIcon from '@/assets/Elysia-logo.svg?react';

interface IntermediateStepsProps {
  displayImage: boolean;
  toolResults: any;
  toolCall: any;
  message: string;
  imageId?: string;
}

const IntermediateSteps = ({
  displayImage = true,
  toolCall,
  toolResults,
  message,
  imageId,
}: IntermediateStepsProps) => {
  return (
    <>
      <Card.Title>
        <div className="d-flex justify-content-between align-items-center">
          <div className="sys-msg-card-img" data-testid="sys-msg-elysia-image">
            {displayImage && <ElyisaIcon />}
          </div>
          {!message && !toolResults?.length && toolCall && !imageId ? (
            <div className="searching-placeholder">
              {toolCall !== 'Document' ? (
                <span>{toolCall}</span>
              ) : (
                <span>Retrieving information</span>
              )}
            </div>
          ) : null}
        </div>
      </Card.Title>
    </>
  );
};

export default IntermediateSteps;
